/**
 * QuickReplies — clickable quick-reply buttons for the simulator.
 * Mirrors the quick-reply UI in the agent flow chat panel: options encoded as
 * [bracketed] text in the latest bot message are rendered as buttons that, when
 * clicked, send that option back as the next user message.
 */

interface QuickRepliesProps {
  replies: string[]
  onSelect: (reply: string) => void
  disabled?: boolean
}

export function QuickReplies({ replies, onSelect, disabled }: QuickRepliesProps) {
  if (!replies || replies.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 mt-2 mb-1 mx-1">
      {replies.map((reply, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect(reply)}
          disabled={disabled}
          className="text-xs px-3 py-1.5 rounded-full border border-blue-300 bg-white text-blue-600 hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {reply}
        </button>
      ))}
    </div>
  )
}
